import { render, staticRenderFns } from "./TagPage.vue?vue&type=template&id=5f101bc0&scoped=true&"
import script from "./TagPage.vue?vue&type=script&lang=js&"
export * from "./TagPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f101bc0",
  null
  
)

export default component.exports